import { createApp } from 'vue'

/* import './styles/element-variables.scss' */

import '@/styles/index.scss' // global css


import App from './App.vue'
import store from './store'
import router from './router'
import i18n from './i18n'

createApp(App)
  .use(store)
  .use(router)
  .use(i18n)
  .mount('#app')

  // Usar en main.js
import { loadAdSense } from './utils/adsense';
loadAdSense();